<template>
  <div class="page-container">
    <van-nav-bar
      left-arrow
      fixed
      :z-index="10"
      @click-left="goableBack()"
      :title="protocol.title"></van-nav-bar>
    <div class="content" v-html="protocol.content"></div>
  </div>
</template>

<script>
import { getprotocol } from "@/api/product"
export default {
  name: "index",
  data: () => ({
    id: "",
    productId: "",
    amount: "",
    attachRate: "",
    rateCouponIds: [],
    protocol: {}
  }),
  beforeMount() {
    this.id = this.$route.query.id
    this.productId = this.$route.query.productId
    this.tradeAmount = this.$route.query.tradeAmount
    this.attachRate = this.$route.query.attachRate
    this.rateCouponIds = this.$route.query.rateCouponIds
    this.fetch()
  },
  methods: {
    fetch() {
      getprotocol(
        this.productId,
        this.id,
        this.tradeAmount,
        this.attachRate,
        this.rateCouponIds
      )
        .then((data) => {
          this.protocol = data
        })
        .catch((e) => {
          // eslint-disable-next-line no-console
          console.info(e)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  padding: 20px;
}
.van-nav-bar {
  background: #fff;

  ::v-deep .van-nav-bar__title {
    color: @dark;
  }
  ::v-deep .van-icon {
    color: @dark !important;
  }
}
</style>
